const initialState = {
  isLoggedIn: false,
};

export default initialState;
